import _slicedToArray from "/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
var _ref2;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// src/index.ts
import Select from "react-select";

// src/useAsyncPaginate.ts
import { useCallback as useCallback2, useState as useState2 } from "react";

// src/useAsyncPaginateBase.ts
import { useLazyRef } from "@vtaits/use-lazy-ref";
import { useCallback, useEffect, useRef, useState } from "react";
import useIsMountedRef from "use-is-mounted-ref";
import useLatest from "use-latest";

// src/defaultReduceOptions.ts
var defaultReduceOptions = function defaultReduceOptions(prevOptions, loadedOptions) {
  return [].concat(_toConsumableArray(prevOptions), _toConsumableArray(loadedOptions));
};

// src/defaultShouldLoadMore.ts
var AVAILABLE_DELTA = 10;
var defaultShouldLoadMore = function defaultShouldLoadMore(scrollHeight, clientHeight, scrollTop) {
  var bottomBorder = scrollHeight - clientHeight - AVAILABLE_DELTA;
  return bottomBorder < scrollTop;
};

// src/getInitialCache.ts
var getInitialCache = function getInitialCache(params) {
  return {
    isFirstLoad: true,
    options: [],
    hasMore: true,
    isLoading: false,
    additional: params.additional
  };
};

// src/getInitialOptionsCache.ts
var getInitialOptionsCache = function getInitialOptionsCache(_ref) {
  var options = _ref.options,
    defaultOptions = _ref.defaultOptions,
    additional = _ref.additional,
    defaultAdditional = _ref.defaultAdditional;
  var initialOptions = defaultOptions === true ? null : Array.isArray(defaultOptions) ? defaultOptions : options;
  if (initialOptions) {
    return {
      "": {
        isFirstLoad: false,
        isLoading: false,
        options: initialOptions,
        hasMore: true,
        additional: defaultAdditional || additional
      }
    };
  }
  return {};
};

// src/requestOptions.ts
import { getResult } from "krustykrab";
import sleep from "sleep-promise";

// src/validateResponse.ts
var errorText = '[react-select-async-paginate] response of "loadOptions" should be an object with "options" prop, which contains array of options.';
var checkIsResponse = function checkIsResponse(response) {
  if (!response) {
    return false;
  }
  var options = response.options,
    hasMore = response.hasMore;
  if (!Array.isArray(options)) {
    return false;
  }
  if (typeof hasMore !== "boolean" && typeof hasMore !== "undefined") {
    return false;
  }
  return true;
};
var validateResponse = function validateResponse(response) {
  if (!checkIsResponse(response)) {
    console.error(errorText, "Received:", response);
    throw new Error(errorText);
  }
  return true;
};

// src/requestOptions.ts
var requestOptions = function requestOptions(_x, _x2, _x3, _x4, _x5, _x6) {
  return (_ref2 = _ref2 || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(caller, paramsRef, optionsCacheRef, debounceTimeout, setOptionsCache, reduceOptions) {
    var currentInputValue, isCacheEmpty, currentOptions, newInputValue, loadOptions, result, response, options, hasMore, newAdditional;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          currentInputValue = paramsRef.current.inputValue;
          isCacheEmpty = !optionsCacheRef.current[currentInputValue];
          currentOptions = isCacheEmpty ? getInitialCache(paramsRef.current) : optionsCacheRef.current[currentInputValue];
          if (!(currentOptions.isLoading || !currentOptions.hasMore)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return");
        case 5:
          setOptionsCache(function (prevOptionsCache) {
            return _objectSpread({}, prevOptionsCache, _defineProperty({}, currentInputValue, _objectSpread({}, currentOptions, {
              isLoading: true
            })));
          });
          if (!(debounceTimeout > 0 && caller === "input-change")) {
            _context.next = 13;
            break;
          }
          _context.next = 9;
          return sleep(debounceTimeout);
        case 9:
          newInputValue = paramsRef.current.inputValue;
          if (!(currentInputValue !== newInputValue)) {
            _context.next = 13;
            break;
          }
          setOptionsCache(function (prevOptionsCache) {
            if (isCacheEmpty) {
              var itemForDelete = prevOptionsCache[currentInputValue],
                restCache = _objectWithoutProperties(prevOptionsCache, [currentInputValue].map(_toPropertyKey));
              return restCache;
            }
            return _objectSpread({}, prevOptionsCache, _defineProperty({}, currentInputValue, _objectSpread({}, currentOptions, {
              isLoading: false
            })));
          });
          return _context.abrupt("return");
        case 13:
          loadOptions = paramsRef.current.loadOptions;
          _context.next = 16;
          return getResult(Promise.resolve().then(function () {
            return loadOptions(currentInputValue, currentOptions.options, currentOptions.additional);
          }));
        case 16:
          result = _context.sent;
          if (!result.isErr()) {
            _context.next = 20;
            break;
          }
          setOptionsCache(function (prevOptionsCache) {
            return _objectSpread({}, prevOptionsCache, _defineProperty({}, currentInputValue, _objectSpread({}, currentOptions, {
              isLoading: false
            })));
          });
          return _context.abrupt("return");
        case 20:
          response = result.unwrap();
          if (validateResponse(response)) {
            options = response.options, hasMore = response.hasMore;
            newAdditional = Object.hasOwn(response, "additional") ? response.additional : currentOptions.additional;
            setOptionsCache(function (prevOptionsCache) {
              return _objectSpread({}, prevOptionsCache, _defineProperty({}, currentInputValue, _objectSpread({}, currentOptions, {
                options: reduceOptions(currentOptions.options, options, newAdditional),
                hasMore: !!hasMore,
                isLoading: false,
                isFirstLoad: false,
                additional: newAdditional
              })));
            });
          }
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }))).apply(this, arguments);
};

// src/useAsyncPaginateBase.ts
var increaseStateId = function increaseStateId(prevStateId) {
  return prevStateId + 1;
};
var useAsyncPaginateBase = function useAsyncPaginateBase(params) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultOptions = params.defaultOptions,
    _params$loadOptionsOn = params.loadOptionsOnMenuOpen,
    loadOptionsOnMenuOpen = _params$loadOptionsOn === void 0 ? true : _params$loadOptionsOn,
    _params$debounceTimeo = params.debounceTimeout,
    debounceTimeout = _params$debounceTimeo === void 0 ? 0 : _params$debounceTimeo,
    inputValue = params.inputValue,
    menuIsOpen = params.menuIsOpen,
    _params$filterOption = params.filterOption,
    filterOption = _params$filterOption === void 0 ? null : _params$filterOption,
    _params$reduceOptions = params.reduceOptions,
    reduceOptions = _params$reduceOptions === void 0 ? defaultReduceOptions : _params$reduceOptions,
    _params$shouldLoadMor = params.shouldLoadMore,
    shouldLoadMore = _params$shouldLoadMor === void 0 ? defaultShouldLoadMore : _params$shouldLoadMor;
  var isMountedRef = useIsMountedRef();
  var reduceOptionsRef = useLatest(reduceOptions);
  var loadOptionsOnMenuOpenRef = useLatest(loadOptionsOnMenuOpen);
  var isInitRef = useRef(true);
  var paramsRef = useRef(params);
  paramsRef.current = params;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    _stateId = _useState2[0],
    setStateId = _useState2[1];
  var optionsCacheRef = useLazyRef(function () {
    return getInitialOptionsCache(params);
  });
  var callRequestOptionsRef = useLatest(function (caller) {
    requestOptions(caller, paramsRef, optionsCacheRef, debounceTimeout, function (reduceState) {
      optionsCacheRef.current = reduceState(optionsCacheRef.current);
      if (isMountedRef.current) {
        setStateId(increaseStateId);
      }
    }, reduceOptionsRef.current);
  });
  var handleScrolledToBottom = useCallback(function () {
    var currentInputValue = paramsRef.current.inputValue;
    var currentOptions2 = optionsCacheRef.current[currentInputValue];
    if (currentOptions2) {
      callRequestOptionsRef.current("menu-scroll");
    }
  }, [callRequestOptionsRef, optionsCacheRef]);
  useEffect(function () {
    if (isInitRef.current) {
      isInitRef.current = false;
    } else {
      optionsCacheRef.current = {};
      setStateId(increaseStateId);
    }
    if (defaultOptions === true) {
      callRequestOptionsRef.current("autoload");
    }
  }, deps);
  useEffect(function () {
    if (menuIsOpen && !optionsCacheRef.current[inputValue]) {
      callRequestOptionsRef.current("input-change");
    }
  }, [callRequestOptionsRef, inputValue, menuIsOpen, optionsCacheRef]);
  useEffect(function () {
    if (menuIsOpen && !optionsCacheRef.current[""] && loadOptionsOnMenuOpenRef.current) {
      callRequestOptionsRef.current("menu-toggle");
    }
  }, [callRequestOptionsRef, loadOptionsOnMenuOpenRef, menuIsOpen, optionsCacheRef]);
  var currentOptions = optionsCacheRef.current[inputValue] || getInitialCache(params);
  return {
    handleScrolledToBottom: handleScrolledToBottom,
    shouldLoadMore: shouldLoadMore,
    filterOption: filterOption,
    isLoading: currentOptions.isLoading,
    isFirstLoad: currentOptions.isFirstLoad,
    options: currentOptions.options
  };
};

// src/useAsyncPaginate.ts
var useAsyncPaginate = function useAsyncPaginate(params) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var inputValueParam = params.inputValue,
    menuIsOpenParam = params.menuIsOpen,
    defaultInputValueParam = params.defaultInputValue,
    defaultMenuIsOpenParam = params.defaultMenuIsOpen,
    onInputChangeParam = params.onInputChange,
    onMenuCloseParam = params.onMenuClose,
    onMenuOpenParam = params.onMenuOpen;
  var _useState3 = useState2(defaultInputValueParam || ""),
    _useState4 = _slicedToArray(_useState3, 2),
    inputValueState = _useState4[0],
    setInputValue = _useState4[1];
  var _useState5 = useState2(!!defaultMenuIsOpenParam),
    _useState6 = _slicedToArray(_useState5, 2),
    menuIsOpenState = _useState6[0],
    setMenuIsOpen = _useState6[1];
  var inputValue = typeof inputValueParam === "string" ? inputValueParam : inputValueState;
  var menuIsOpen = typeof menuIsOpenParam === "boolean" ? menuIsOpenParam : menuIsOpenState;
  var onInputChange = useCallback2(function (nextInputValue, actionMeta) {
    if (onInputChangeParam) {
      onInputChangeParam(nextInputValue, actionMeta);
    }
    setInputValue(nextInputValue);
  }, [onInputChangeParam]);
  var onMenuClose = useCallback2(function () {
    if (onMenuCloseParam) {
      onMenuCloseParam();
    }
    setMenuIsOpen(false);
  }, [onMenuCloseParam]);
  var onMenuOpen = useCallback2(function () {
    if (onMenuOpenParam) {
      onMenuOpenParam();
    }
    setMenuIsOpen(true);
  }, [onMenuOpenParam]);
  var baseResult = useAsyncPaginateBase(_objectSpread({}, params, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen
  }), deps);
  return _objectSpread({}, baseResult, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen
  });
};

// src/useComponents.ts
import { useMemo as useMemo2 } from "react";
import { components as defaultComponents } from "react-select";

// src/wrapMenuList.tsx
import composeRefs from "@seznam/compose-react-refs";
import { useCallback as useCallback3, useEffect as useEffect2, useMemo, useRef as useRef2 } from "react";
import { jsx } from "react/jsx-runtime";
var CHECK_TIMEOUT = 300;
function wrapMenuList(MenuList2) {
  function WrappedMenuList(props) {
    var selectProps = props.selectProps,
      innerRef = props.innerRef;
    var handleScrolledToBottom = selectProps.handleScrolledToBottom,
      shouldLoadMore = selectProps.shouldLoadMore;
    var checkTimeoutRef = useRef2();
    var menuListRef = useRef2(null);
    var shouldHandle = useCallback3(function () {
      var el = menuListRef.current;
      if (!el) {
        return false;
      }
      var scrollTop = el.scrollTop,
        scrollHeight = el.scrollHeight,
        clientHeight = el.clientHeight;
      return shouldLoadMore(scrollHeight, clientHeight, scrollTop);
    }, [shouldLoadMore]);
    var checkAndHandle = useCallback3(function () {
      if (shouldHandle()) {
        if (handleScrolledToBottom) {
          handleScrolledToBottom();
        }
      }
    }, [shouldHandle, handleScrolledToBottom]);
    var setCheckAndHandleTimeout = useMemo(function () {
      var res = function res() {
        checkAndHandle();
        checkTimeoutRef.current = setTimeout(res, CHECK_TIMEOUT);
      };
      return res;
    }, [checkAndHandle]);
    useEffect2(function () {
      setCheckAndHandleTimeout();
      return function () {
        if (checkTimeoutRef.current) {
          clearTimeout(checkTimeoutRef.current);
        }
      };
    }, []);
    return /* @__PURE__ */jsx(MenuList2, _objectSpread({}, props, {
      innerRef: composeRefs(innerRef, menuListRef)
    }));
  }
  return WrappedMenuList;
}

// src/useComponents.ts
var MenuList = wrapMenuList(defaultComponents.MenuList);
var useComponents = function useComponents(components) {
  return useMemo2(function () {
    return _objectSpread({
      MenuList: MenuList
    }, components);
  }, [components]);
};

// src/withAsyncPaginate.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var defaultCacheUniqs = [];
var defaultComponents2 = {};
function withAsyncPaginate(SelectComponent) {
  function WithAsyncPaginate(props) {
    var _props$components = props.components,
      components = _props$components === void 0 ? defaultComponents2 : _props$components,
      _props$selectRef = props.selectRef,
      selectRef = _props$selectRef === void 0 ? void 0 : _props$selectRef,
      isLoadingProp = props.isLoading,
      _props$cacheUniqs = props.cacheUniqs,
      cacheUniqs = _props$cacheUniqs === void 0 ? defaultCacheUniqs : _props$cacheUniqs,
      rest = _objectWithoutProperties(props, ["components", "selectRef", "isLoading", "cacheUniqs"]);
    var asyncPaginateProps = useAsyncPaginate(rest, cacheUniqs);
    var processedComponents = useComponents(components);
    var isLoading = typeof isLoadingProp === "boolean" ? isLoadingProp : asyncPaginateProps.isLoading;
    return /* @__PURE__ */jsx2(SelectComponent, _objectSpread({}, props, asyncPaginateProps, {
      isLoading: isLoading,
      components: processedComponents,
      ref: selectRef
    }));
  }
  return WithAsyncPaginate;
}

// src/reduceGroupedOptions.ts
var checkGroup = function checkGroup(group) {
  if (!group) {
    return false;
  }
  var label = group.label,
    options = group.options;
  if (typeof label !== "string" && typeof label !== "undefined") {
    return false;
  }
  if (!Array.isArray(options)) {
    return false;
  }
  return true;
};
var reduceGroupedOptions = function reduceGroupedOptions(prevOptions, loadedOptions) {
  var res = prevOptions.slice();
  var mapLabelToIndex = {};
  var prevOptionsIndex = 0;
  var prevOptionsLength = prevOptions.length;
  var _iterator = _createForOfIteratorHelper(loadedOptions),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var optionOrGroup = _step.value;
      var group = checkGroup(optionOrGroup) ? optionOrGroup : {
        options: [optionOrGroup]
      };
      var _group$label = group.label,
        label = _group$label === void 0 ? "" : _group$label;
      var groupIndex = mapLabelToIndex[label];
      if (typeof groupIndex !== "number") {
        for (; prevOptionsIndex < prevOptionsLength && typeof mapLabelToIndex[label] !== "number"; ++prevOptionsIndex) {
          var prevGroup = prevOptions[prevOptionsIndex];
          if (checkGroup(prevGroup)) {
            mapLabelToIndex[prevGroup.label || ""] = prevOptionsIndex;
          }
        }
        groupIndex = mapLabelToIndex[label];
      }
      if (typeof groupIndex !== "number") {
        mapLabelToIndex[label] = res.length;
        res.push(group);
      } else {
        res[groupIndex] = _objectSpread({}, res[groupIndex], {
          options: [].concat(_toConsumableArray(res[groupIndex].options), _toConsumableArray(group.options))
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return res;
};

// src/index.ts
var AsyncPaginate = withAsyncPaginate(Select);
export { AsyncPaginate, checkIsResponse, reduceGroupedOptions, useAsyncPaginate, useAsyncPaginateBase, useComponents, validateResponse, withAsyncPaginate, wrapMenuList };